// // import React from "react";

// // // Safe Imports
// // import { 
// //   FaHandshake, 
// //   FaGlobe, 
// //   FaMoneyCheck,
// //   FaBuilding,
// //   FaUsers,
// //   FaAward
// // } from "react-icons/fa";

// // import { PiBuildingsBold } from "react-icons/pi";
// // import { 
// //   MdOutlinePolicy, 
// //   MdBusinessCenter,
// //   MdBook 
// // } from "react-icons/md";

// // export default function GrowthPillars() {
// //   const pillars = [
// //     {
// //       icon: <FaGlobe className="w-8 h-8" />,
// //       title: "Global Outreach",
// //     },
// //     {
// //       icon: <MdBusinessCenter className="w-8 h-8" />,
// //       title: "Business Development Services",
// //     },
// //     {
// //       icon: <MdBook className="w-8 h-8" />,
// //       title: "Knowledge Work",
// //     },
// //     {
// //       icon: <MdOutlinePolicy className="w-8 h-8" />,
// //       title: "Policy Advocacy",
// //     },
// //     {
// //       icon: <FaGlobe className="w-8 h-8" />,
// //       title: "Sustainability Services",
// //     },
// //     {
// //       icon: <FaAward className="w-8 h-8" />,
// //       title: "CSR Services",
// //     },
// //   ];

// //   const focusAreas = [
// //     "Make in India & Ease of Doing Business",
// //     "MSME Growth",
// //     "Digital Economy",
// //     "Sustainability & Environment",
// //   ];

// //   const stats = [
// //     { number: "4,50,000+", label: "Members" },
// //     { number: "4,000+", label: "Member Companies" },
// //     { number: "100+", label: "Countries Connected" },
// //     { number: "5,000+", label: "Events & Programs" },
// //     { number: "250+", label: "Reports & Publications" },
// //   ];

// //   return (
// //     <section className="py-5 bg-white">
// //       <div className="mx-auto px-6">
// //         {/* Heading */}
// //         <div className="text-center mb-7">
// //           {/* <p className="text-orange-600 font-medium tracking-widest">OUR PILLARS</p> */}
// //           <h2 className="text-[20px] font-bold text-[#cf121c] mt-2">
// //             OUR PILLARS
// //           </h2>
// //         </div>

// //         <div className="grid lg:grid-cols-12 gap-8">
// //           {/* Main Pillars Grid */}
// //           <div className="lg:col-span-8">
// //             <div className="grid md:grid-cols-3 gap-4">
// //               {pillars.map((pillar, index) => (
// //                 <div
// //                   key={index}
// //                   className="group bg-white border border-gray-100 hover:border-[#B5121B] hover:shadow-xl transition-all duration-300 rounded-2xl p-[8px] text-center hover:-translate-y-1 cursor-pointer"
// //                 >
// //                   <div className="mx-auto w-10 h-10 flex items-center justify-center bg-orange-50 group-hover:bg-[#B5121B] text-[#E1560C] group-hover:text-white rounded-2xl transition-all duration-300">
// //                     {pillar.icon}
// //                   </div>
// //                   <h3 className="mt-3 font-semibold text-[13px] leading-tight text-gray-900 group-hover:text-[#B5121B] transition-colors">
// //                     {pillar.title}
// //                   </h3>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>

// //           {/* Focus Areas Sidebar */}
// //           <div className="lg:col-span-4">
// //             <div className="bg-[#FFF9EC] rounded-3xl p-8 h-full sticky top-8">
// //               <h3 className="text-2xl font-semibold text-gray-900 mb-1">
// //                 Focus Areas
// //               </h3>
// //               <p className="text-gray-600 mb-1 text-[12px]">
// //                 Sectors we actively represent and advocate for
// //               </p>

// //               <div className="flex flex-wrap gap-2">
// //                 {focusAreas.map((area, idx) => (
// //                   <div
// //                     key={idx}
// //                     className="bg-white hover:bg-[#B5121B] hover:text-white transition-all px-5 py-3 rounded-2xl text-[12px] font-medium border border-gray-200 hover:border-[#B5121B] cursor-pointer"
// //                   >
// //                     {area}
// //                   </div>
// //                 ))}
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Stats Section */}
// //         {/* <div className="mt-16 pt-12 border-t border-gray-200">
// //           <div className="grid grid-cols-2 md:grid-cols-5 gap-8 text-center">
// //             {stats.map((stat, index) => (
// //               <div key={index} className="group">
// //                 <div className="text-4xl md:text-5xl font-bold text-[#B5121B] group-hover:scale-110 transition-transform">
// //                   {stat.number}
// //                 </div>
// //                 <div className="text-gray-600 mt-2 text-sm md:text-base font-medium">
// //                   {stat.label}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div> */}
// //       </div>
// //     </section>
// //   );
// // }




// // new code 



// import React from "react";

// // Safe Imports
// import { 
//   FaGlobe, 
//   FaAward
// } from "react-icons/fa";

// import { 
//   MdBusinessCenter,
//   MdBook,
//   MdOutlinePolicy 
// } from "react-icons/md";

// import focusBG from "../assets/focus-bg.png";

// export default function GrowthPillars() {
//   const pillars = [
//     {
//       icon: <FaGlobe className="w-8 h-8" />,
//       title: "Global Outreach",
//     },
//     {
//       icon: <MdBusinessCenter className="w-8 h-8" />,
//       title: "Business Development Services",
//     },
//     {
//       icon: <MdBook className="w-8 h-8" />,
//       title: "Knowledge Work",
//     },
//     {
//       icon: <MdOutlinePolicy className="w-8 h-8" />,
//       title: "Policy Advocacy",
//     },
//     {
//       icon: <FaGlobe className="w-8 h-8" />,
//       title: "Sustainability Services",
//     },
//     {
//       icon: <FaAward className="w-8 h-8" />,
//       title: "CSR Services",
//     },
//   ];

//   const focusAreas = [
//     "Make in India",
//     "Ease of Doing Business",
//     "MSME Growth",
//     "Digital Economy",
//     "Sustainability & Environment",
//   ];

//   return (
//     // <section className="py-5 bg-white">
// <section
//   className="py-5 -mt-[5.5rem] pt-20"
//   style={{
//     backgroundImage: `url(${focusBG})`,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//     backgroundAttachment: "scroll",
//   }}
// >

//       <div className="mx-auto px-6">
        
//         {/* Main Content Grid - Both Sections at Same Level */}
//         <div className="grid lg:grid-cols-12 gap-8 lg:gap-10">
          
//           {/* OUR PILLARS Section */}
//           <div className="lg:col-span-8">
//             <div className="mb-6">
//               <h2 className="text-[20px] font-bold text-[#da2128] text-center">
//                 FOCUS AREAS
//               </h2>
//             </div>

//             <div className="grid md:grid-cols-3 gap-4">
//               {pillars.map((pillar, index) => (
//                 <div
//                   key={index}
//                 //   className="group bg-white border border-gray-100 hover:border-[#B5121B] hover:shadow-xl transition-all duration-300 rounded-2xl p-[8px] text-center hover:-translate-y-1 cursor-pointer"
//                 // >
//                 className="group bg-white/50 border border-gray-100 
//                              hover:border-[#B5121B] 
//                              shadow-[3px_2px_6px_0px_grey] 
//                              transition-all duration-300 
//                              rounded-2xl p-[8px] text-center 
//                              hover:-translate-y-1 cursor-pointer"
//                 >
//                   <div className="mx-auto w-10 h-10 flex items-center justify-center bg-orange-50 group-hover:bg-[#B5121B] text-[#e65925] group-hover:text-white rounded-2xl transition-all duration-300">
//                     {pillar.icon}
//                   </div>
//                   <h3 className="mt-3 font-semibold text-[13px] leading-tight text-gray-900 group-hover:text-[#B5121B] transition-colors">
//                     {pillar.title}
//                   </h3>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Focus Areas Section - Same Level */}
//           <div className="lg:col-span-4">
//             <h2 className="text-[20px] font-bold text-[#da2128] mb-3">
//                 OUR PILLARS 
//               </h2>
//            <div className="bg-[#FFF9EC]/80 rounded-3xl p-4 h-[85%] shadow-[2px_2px_6px_-2px_rgba(0,0,0,0.15)]">
              
//               {/* <p className="text-gray-600 mb-6 text-[13px]">
//                 Sectors we actively represent and advocate for
//               </p> */}

//               <div className="flex flex-wrap gap-3 align-center items-center justify-center h-[100%]">
//                 {focusAreas.map((area, idx) => (
//                   <div
//                     key={idx}
//                     className="bg-[#FFFFFF] hover:bg-[#B5121B] hover:text-white transition-all px-5 py-4 rounded-2xl text-[12px] font-medium border border-gray-200 hover:border-[#B5121B] cursor-pointer"
//                   >
//                     {area}
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//         </div>

//       </div>
//     </section>
//   );
// }



// new code 




import React from "react";

// Safe Imports
import { 
  FaGlobe, 
  FaAward 
} from "react-icons/fa";

import { 
  MdBusinessCenter,
  MdBook,
  MdOutlinePolicy,
  MdOutlineSettings,     // Added for Make in India
  MdTrendingUp,          // Added for MSME Growth
  MdComputer             // Added for Digital Economy
} from "react-icons/md";

import focusBG from "../assets/focus-bg.png";

export default function GrowthPillars() {
  const pillars = [
    {
      icon: <FaGlobe className="w-8 h-8" />,
      title: "Global Outreach",
    },
    {
      icon: <MdBusinessCenter className="w-8 h-8" />,
      title: "Business Development Services",
    },
    {
      icon: <MdBook className="w-8 h-8" />,
      title: "Knowledge Work",
    },
    {
      icon: <MdOutlinePolicy className="w-8 h-8" />,
      title: "Policy Advocacy",
    },
    {
      icon: <FaGlobe className="w-8 h-8" />,
      title: "Sustainability Services",
    },
    {
      icon: <FaAward className="w-8 h-8" />,
      title: "CSR Services",
    },
  ];

  const focusAreas = [
    { 
      name: "Make in India", 
      icon: <MdOutlineSettings className="w-5 h-5" /> 
    },
    { 
      name: "Ease of Doing Business", 
      icon: <MdOutlinePolicy className="w-5 h-5" /> 
    },
    { 
      name: "MSME Growth", 
      icon: <MdTrendingUp className="w-5 h-5" /> 
    },
    { 
      name: "Digital Economy", 
      icon: <MdComputer className="w-5 h-5" /> 
    },
    { 
      name: "Sustainability & Environment", 
      icon: <FaGlobe className="w-5 h-5" /> 
    },
  ];

  return (
    <section
      className="py-5 -mt-[5.5rem] pt-20"
      style={{
        // backgroundImage: `url(${focusBG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
      }}
    >
      <div className="mx-auto px-6">
        
        {/* Main Content Grid - Both Sections at Same Level */}
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10">
          
          {/* OUR PILLARS Section */}
          <div className="lg:col-span-8">
            <div className="mb-6">
              <h2 className="text-[20px] text-[#da2128] text-center font-semibold leading-tight font-rethink">
                Focus Areas
              </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-4">
              {pillars.map((pillar, index) => (
                <div
                  key={index}
                  className="group bg-white/50 border border-gray-100 
                             hover:border-[#B5121B] 
                             shadow-[3px_2px_6px_0px_grey] 
                             transition-all duration-300 
                             rounded-2xl p-[8px] text-center 
                             hover:-translate-y-1 cursor-pointer"
                >
                  <div className="mx-auto w-10 h-10 flex items-center justify-center bg-orange-50 group-hover:bg-[#B5121B] text-[#e65925] group-hover:text-white rounded-2xl transition-all duration-300">
                    {pillar.icon}
                  </div>
                  <h3 className="mt-3 font-semibold text-[13px] leading-tight text-gray-900 group-hover:text-[#B5121B] transition-colors">
                    {pillar.title}
                  </h3>
                </div>
              ))}
            </div>
          </div>

          {/* Focus Areas Section - Same Level */}
          <div className="lg:col-span-4">
            <h2 className="text-[20px] text-[#da2128] mb-3 text-center font-semibold leading-tight font-rethink">
                Our Pillars
            </h2>
            
            <div className="rounded-3xl p-4 h-[85%] shadow-[2px_2px_6px_-2px_rgba(0,0,0,0.15)]" style={{ background: "linear-gradient(to top, #d299c2 0%, #fef9d7 100%)" }}>
              
              <div className="flex flex-wrap gap-3 items-center justify-center h-[100%]">
  {focusAreas.map((area, idx) => (
    <div
      key={idx}
      className="group flex items-center gap-2 bg-[#FFFFFF] hover:bg-[#f59c00] hover:text-white transition-all duration-300 px-5 py-4 rounded-2xl text-[12px] font-medium border border-gray-200 hover:border-[#f59c00] cursor-pointer"
    >
      <span className="text-[#da2128] group-hover:text-[#ffff] transition-colors duration-300">
        {area.icon}
      </span>

      <span className="transition-colors duration-300">
        {area.name}
      </span>
    </div>
  ))}
</div>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}